import React, { useEffect, useState, Fragment } from 'react';
import {isMonthAndYearEmpty,isNumeric,getStatusFlagValue,getButtonDisabledStates} from '../Custom/Custom'
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from "react-router-dom";
import messages from '../assets/Messages.json'
import axios from "axios";
import { API_URL } from '../Constant';
import {showLoading } from 'react-global-loading';


function RuralWomenWagesData({ 
  ruralWomenWagesRates, 
  blockAllData,
  yearName,
  monthName,
  userInfoObject,
  config,
  districtCode,
  resetMothAndYearAndDistrictField,
  ruralWomenEmptyObject,
  averageData,
  monthAndYearValidation,
  payload,
  storedLanguage,
  priceTitle,
  titlesData
  }) {

    const [itemData, setItemData] = useState({});
    const [checkedItems, setCheckedItems] = useState([]);
    // const [remarkText, setRemarkText] = useState(ruralWomenWagesRates[0]?.RejectRemark || '');
    const navigate = useNavigate();
    const {
      isSaveBtnDisable,
      isSubmitBtnDisable,
      isAcceptBtnDisable,
      isRejectBtnDisable
    } = getButtonDisabledStates(payload, userInfoObject);
    let srNo=0;
    let headQuarterRemark=[
      'Wages is Too Low.',
      'Wages is too High',
      'Worng entry'
      ]
      let otherRemark=[
      'High demand of laboures.',
      'Low demand of laboures.',
      'Entry is correct.',
      'Enter has been amended.',
       ]
    const ruralWomenPropertyNames =[
       "cowTotalWagesAvg",
        "buffaloTotalWagesAvg",
        "showingTotalWagesAvg",
        "weddingTotalWagesAvg",
        "harvestingTotalWagesAvg",
        "threshingTotalWagesAvg",
        "otherTotalWagesAvg",
        "WageMonth",
        "WageYear",
        "BlockCode",
        "LocationCode",
        "BlockName",
        "BuffaloTotalWages",
        "CowTotalWages",
        "CreatedBy",
        "CreatedTime",
        "DistrictCode",
        "DistrictName",
        "DivisionCode",
        "DivisionName",
        "HarvestingTotalWages",
        "LocationName",
        "OtherTotalWages",
        "RegionCode",
        "RegionName",
        "ShowingTotalWages",
        "StatusFlag",
        "ThreshingTotalWages",
        "WeddingTotalWages",
        "Validation",
        "Source",
        "RemarkCow",
        "RemarkBuff",
        "RemarkSowing",
        "RemarkWeeding",
        "RemarkHarvest",
        "RemarkThresh",
        "RemarkOther",
        "RejectRemark",
       
        "CowTotalWagesStyle",
        "BuffaloTotalWagesStyle",
        "ShowingTotalWagesStyle",
        "WeddingTotalWagesStyle",
        "HarvestingTotalWagesStyle",
        "ThreshingTotalWagesStyle",
        "OtherTotalWagesStyle",
        "CowTotalWagesIsRequiredRemark",
        "BuffaloTotalWagesIsRequiredRemark",
        "ShowingTotalWagesIsRequiredRemark",
        "WeddingTotalWagesIsRequiredRemark",
        "HarvestingTotalWagesIsRequiredRemark",
        "ThreshingTotalWagesIsRequiredRemark",
        "OtherTotalWagesIsRequiredRemark",
        "RemarkCowSelectValue",
        "RemarkBuffSelectValue",
        "RemarkSowingSelectValue",
        "RemarkWeedingSelectValue",
        "RemarkHarvestSelectValue",
        "RemarkThreshSelectValue",
        "RemarkOtherSelectValue"

    ]

    
useEffect(() => {
  let ruralWomenWagesData=ruralWomenWagesRates;
  customObjectObjectData(ruralWomenWagesData)
}, [ruralWomenWagesRates])


  const customObjectObjectData=(ruralWomenWagesData)=>{
    const initialData = {};
     ruralWomenWagesData.forEach((item, i) => {
          initialData[i] = { id: i };
          ruralWomenPropertyNames.forEach(property => {
              initialData[i][property] = item?.[property] ?? '';
          });
          });
      setItemData(initialData);
  }

  // handle the add row on add row button  click
const addRow = () => {
  let newCustomObject = [];
   for (let i = 0; i < 1; i++) {
     const newItemAdded = {
       id:i,
      ...ruralWomenEmptyObject
     };
     newCustomObject.push(newItemAdded);
   }
    const dataArray = Object.values(itemData);
    const AddedIndex=dataArray.length
    dataArray.splice(AddedIndex, 0, ...newCustomObject);
    customObjectObjectData(dataArray)    
};

const TOTAL_WAGES_FIELDS = [
  'CowTotalWages',
  'BuffaloTotalWages',
  'ShowingTotalWages',
  'WeddingTotalWages',
  'HarvestingTotalWages',
  'ThreshingTotalWages',
  'OtherTotalWages',
];

/** Total Wages: only digits 0-9, max 6 characters */
const sanitizeTotalWagesInput = (value) =>
  String(value ?? '').replace(/\D/g, '').slice(0, 6);

  
// handle textBox On change Event 
const handleOnChange=async(indexId, field, newValue,)=>{

  // Total Wages (Rs): allow only 0-9 digits, up to 6 digits
  if (TOTAL_WAGES_FIELDS.includes(field)) {
    newValue = sanitizeTotalWagesInput(newValue);
  }

if (field === 'BlockName') {
    if (monthName === '' || yearName === '') {
        toast.error(monthName === '' ? messages.MONTH_MSG : messages.YEAR_NAME_MSG, messages.COLOR_RED);
        newValue = ''; 
    } else {
      const foundObject = Object.values(itemData).find(item => item.BlockName === newValue);
      if (foundObject) {
        toast.error(messages.MUNICIPAL_NAME, messages.COLOR_RED);
        newValue = '';
      }
    }
  }


      if (field === 'BlockName' && newValue !=='') {
        let blockData=blockAllData.find(item => item.BlockName === newValue)
          let wage_avg='';
          let payload= {
             block_code:blockData.BlockCode,
             district_code: districtCode,
             month_name: monthName,
             year_name: yearName,
          }
 

          try {
            showLoading(true);
            const response = await axios.post(`${API_URL}api/labourWages/getLwsWomenAverage`,payload, config);
            const {data,status}=response.data;
            wage_avg=data.lwsaverage[0];
            setItemData(prevItemData => {
                const updatedItemData = {
                  ...prevItemData,
                  [indexId]: {
                  ...prevItemData[indexId],
                  [field]: newValue,
                  "BlockCode":blockData.BlockCode,
                  "cowTotalWagesAvg":wage_avg.cowTotalWagesAvg,
                  "buffaloTotalWagesAvg": wage_avg.buffaloTotalWagesAvg,
                  "showingTotalWagesAvg": wage_avg.showingTotalWagesAvg,
                  "weddingTotalWagesAvg": wage_avg.weddingTotalWagesAvg,
                  "harvestingTotalWagesAvg":wage_avg.harvestingTotalWagesAvg,
                  "threshingTotalWagesAvg": wage_avg.threshingTotalWagesAvg,
                  "otherTotalWagesAvg": wage_avg.otherTotalWagesAvg
                }
                };
                  return updatedItemData;
                });
                showLoading(false);
          
          }catch (error) {
    
            }
     }else{

          setItemData(prevItemData => {
            const updatedItemData = {
              ...prevItemData,
              [indexId]: {
              ...prevItemData[indexId],
              [field]: newValue,
                }
            };
              return updatedItemData;
            });
        }

  }


// handle textBox On Blur Event action
const handleCheckVariation = (indexId, styleField,remarkRequiredField,newValue, average, variation) => {

    
      if(!isNumeric(newValue)){
        toast.error(messages.NUMERIC_MSG, messages.COLOR_RED);
        toast.error(" Are you sure, 0 can be enterd?", messages.COLOR_RED);
        newValue=0;
      }
       if(average===null || average===''){
        average=0
       }
      if(newValue===null || newValue==='' || newValue==='NaN'){
        newValue=0
       }
  
      let dynamicStylesForTextBox = {};
      let isRequiredRemark = false;
  
      if (newValue !== 0) {
          let dif = average * variation / 100;
         if (variation === 0 || dif === 0) {
              return;
          }
          if (newValue > (parseFloat(average) + dif) || newValue < (average - dif)) {
              toast.error(messages.VARIATION_MSG, messages.COLOR_RED);
              dynamicStylesForTextBox = {
                  borderColor: 'rgb(220, 223, 225) rgb(220, 223, 225) rgb(220, 223, 225) red',
                  borderStyle: 'solid',
                  borderWidth: '1px 1px 1px 6px'
              };
               newValue = dynamicStylesForTextBox;
               isRequiredRemark = true;
              
  
          } else {
              dynamicStylesForTextBox = {
                  borderColor: '#dcdfe1',
                  borderStyle: 'solid',
                  borderWidth: '1px 1px 1px 6px'
              };
              isRequiredRemark = false;
              newValue = dynamicStylesForTextBox;
          }
      }


  
      setItemData(prevItemData => ({
        ...prevItemData,
        [indexId]: {
            ...prevItemData[indexId],
            [styleField]: newValue,
            [remarkRequiredField]: isRequiredRemark
        }
    }));

  };

//reamark html dropdown 
  const remarkDropDown = ( item, i,selectedValueKey, forRemarkTextKey,requiredKey='') => {
    let headQuarterSelected='';
    let otherSelected='';

    if(headQuarterRemark.includes(item[forRemarkTextKey])){
      headQuarterSelected=item[forRemarkTextKey]
    }
    if(otherRemark.includes(item[forRemarkTextKey])){
      otherSelected=item[forRemarkTextKey]
    }
    return (
      <>
         {/* {  item[forRemarkTextKey] && (
          <label className="text-danger danger_msg_fontSize">{ item[forRemarkTextKey]}</label>
        )}  */}
           {
          (userInfoObject.userLevel !=='HEAD QUARTER') &&   
          (!otherRemark.includes(item[forRemarkTextKey])) && item[forRemarkTextKey] &&
          <label className="text-danger danger_msg_fontSize">{ item[forRemarkTextKey]}</label>
          }

         {
          (userInfoObject.userLevel === 'HEAD QUARTER') &&   
          (!headQuarterRemark.includes(item[forRemarkTextKey])) && item[forRemarkTextKey] &&
          <label className="text-danger danger_msg_fontSize">{ item[forRemarkTextKey]}</label>
         } 
         
         { userInfoObject.userLevel==='HEAD QUARTER'?
          <select
          key={`thead-${i}`}
          className="form-select"
          name={`${selectedValueKey}${i}`}
          id={`${selectedValueKey}${i}`}
          value={headQuarterSelected?headQuarterSelected:item[selectedValueKey]}
          onChange={e => handleOnChangeRemark(item.id, selectedValueKey,forRemarkTextKey, e.target.value,requiredKey)}
          >
           <option value="">[--Select--]</option>
           { headQuarterRemark.map((remarkItem,i)=>{
            return (
            <option value={remarkItem} key={i}>{++i}</option>

          )})}
          </select>
          
         :
          <select
          key={`thead-${i}`}
          className="form-select"
          name={`${selectedValueKey}${i}`}
          id={`${selectedValueKey}${i}`}
          value={otherSelected?otherSelected:item[selectedValueKey]}
          onChange={e => handleOnChangeRemark(item.id, selectedValueKey,forRemarkTextKey, e.target.value,requiredKey)}
          >
          <option value="">[--Select--]</option>
          {otherRemark.map((remarkItem,i)=>{
            return (
            <option value={remarkItem} key={i}>{++i}</option>

           )})}
          </select> 

         }
      
      </>
    );
  };


  
  //Remark on change
  const handleOnChangeRemark=(indexId, field,forRemarkTextKey, newValue,requiredKey='')=>{ 
    let isRequired=false;
    if(newValue===''){
     isRequired=true;
    }
     
      setItemData(prevItemData => {
        const updatedItemData = {
          ...prevItemData,
          [indexId]: {
          ...prevItemData[indexId],
          [field]: newValue,
          [forRemarkTextKey]:'',
          [requiredKey]:isRequired
          }
        };
          return updatedItemData;
        });
  }


  // handleReset Reset All form dara
  const resetForm=()=>{
    resetMothAndYearAndDistrictField()
    }

 //handle delete row
 const deleteRows = () => {
  const dataArray = Object.values(itemData);
  if(checkedItems.length===0){
    toast.error(`Please check the checkbox`, messages.COLOR_RED);
    return false;
  }
  if(dataArray.length>1){
    const updatedItems = dataArray.filter((_, index) => !checkedItems.includes(index));
    customObjectObjectData(updatedItems)
    setCheckedItems([]);
  }else{
    toast.error("Row cannot be deleted", messages.COLOR_RED);
  }

};



  // Function to handle the store chckbox checked data 
  const handleCheckboxChange = (event, index) => {
    if (event.target.checked) {
        setCheckedItems([...checkedItems, index]);
    } else {
        setCheckedItems(checkedItems.filter((item) => item !== index));
    }
}
  


const handleRuralWomannWagesFormData=async(e,buttonType)=>{

  if (monthName === '' || yearName === '') {
    toast.error(monthName === '' ? messages.MONTH_MSG : messages.YEAR_NAME_MSG, messages.COLOR_RED);
    return false;
  }

  let womenData=itemData;
  let clickButtonStatusFlag = getStatusFlagValue(buttonType, userInfoObject.userLevel); //button click status flag
  const customItemCodes = [];
  let statusFlag = '';

    for (let id in womenData) {

      if(womenData[id].BlockName !== ''){

     
        let CowTotalWages = womenData[id].CowTotalWages || 0;
        let BuffaloTotalWages = womenData[id].BuffaloTotalWages || 0;
        let ShowingTotalWages = womenData[id].ShowingTotalWages || 0;
        let WeddingTotalWages = womenData[id].WeddingTotalWages || 0;
        let HarvestingTotalWages = womenData[id].HarvestingTotalWages || 0;
        let ThreshingTotalWages = womenData[id].ThreshingTotalWages || 0;
        let OtherTotalWages = womenData[id].OtherTotalWages || 0;
        let RejectRemark=itemData[0].RejectRemark || '';
        statusFlag = (itemData[id].StatusFlag === '') ? clickButtonStatusFlag : itemData[id].StatusFlag;

        let RemarkCow= handleRemarkTextForPost(womenData[id].RemarkCowSelectValue,womenData[id].RemarkCow)
        let RemarkBuff=handleRemarkTextForPost(womenData[id].RemarkBuffSelectValue,womenData[id].RemarkBuff)
        let RemarkSowing=handleRemarkTextForPost(womenData[id].RemarkSowingSelectValue,womenData[id].RemarkSowing)
        let RemarkWeeding=handleRemarkTextForPost(womenData[id].RemarkWeedingSelectValue, womenData[id].RemarkWeeding)
        let RemarkHarvest=handleRemarkTextForPost(womenData[id].RemarkHarvestSelectValue, womenData[id].RemarkHarvest)
        let RemarkThresh=handleRemarkTextForPost(womenData[id].RemarkThreshSelectValue,womenData[id].RemarkThres)
        let RemarkOther=handleRemarkTextForPost(womenData[id].RemarkOtherSelectValue, womenData[id].RemarkOther)

     

        let BlockName = womenData[id].BlockName;
        let BlockCode = womenData[id].BlockCode;



      if (buttonType !== "REJECT"){
            //Block Name Validation
            if (BlockName==='') {
              toast.error(`Please Select Block`, messages.COLOR_RED);
              return false;
            }

        // Charwaha(Cow)TotalWages Validation 
          if (CowTotalWages !== null && CowTotalWages !== "") {
              let num = parseInt(BlockName);
              if (num < 0 || num > 1000) {
                toast.error(`Please enter a maximum 3 digit number upto 2 decimal place for Charwaha(Cow)TotalWages under block ${BlockName}`, messages.COLOR_RED);
                return false;
            }
          }

          // Charwaha(Buffalow) TotalWages Validation 
          if (BuffaloTotalWages !== null && BuffaloTotalWages !== "") {
            let num = parseInt(BuffaloTotalWages);
              if (num < 0 || num > 1000) {
                toast.error(`Please enter a maximum 3 digit number upto 2 decimal place for Charwaha(Buffalow)TotalWages under block ${BlockName}`, messages.COLOR_RED);
                return false;
              } 
          } 


          // Sowing Total Wages Validation
          if (ShowingTotalWages !== null && ShowingTotalWages !== "") {
          let num = parseInt(ShowingTotalWages);
              if (num < 0 || num > 1000) {
                toast.error(`Please enter a maximum 3 digit number upto 2 decimal place for SowingTotalWages under block ${BlockName}`, messages.COLOR_RED);
                return false;
          } 
        }

        // WeedingTotalWages Validation
          if (WeddingTotalWages !== null && WeddingTotalWages !== "") {
            let num = parseInt(WeddingTotalWages);
              if (num < 0 || num > 1000) {
                toast.error(`Please enter a maximum 3 digit number upto 2 decimal place for WeedingTotalWages under block ${BlockName}`, messages.COLOR_RED);
                return false;
              } 
            
          } 

          //HarvestingTotalWages Validation
          if (HarvestingTotalWages !== null && HarvestingTotalWages !== "") {
            let num = parseInt(HarvestingTotalWages);
              if (num < 0 || num > 1000) {
                toast.error(`Please enter a maximum 3 digit number upto 2 decimal place for HarvestingTotalWages under block ${BlockName}`, messages.COLOR_RED);
                return false;
              } 
          } 

          //ThreshingTotalWages Validation
          if (ThreshingTotalWages !== null && ThreshingTotalWages !== "") {
              var num = parseInt(ThreshingTotalWages);
              if (num < 0 || num > 1000) {
                toast.error(`Please enter a maximum 3 digit number upto 2 decimal place for ThreshingTotalWages under block ${BlockName}`, messages.COLOR_RED);
                return false;
              } 
          } 

          //OtherTotalWages Validation
          if (OtherTotalWages !== null && OtherTotalWages !== "") {
              let num = parseInt(OtherTotalWages);
              if (num < 0 || num > 1000) {
                toast.error(`Please enter a maximum 3 digit number upto 2 decimal place for OtherTotalWages under block ${BlockName}`, messages.COLOR_RED);
                return false;
              } 
            
          } 


              // Remark Vaalidation
            for (let i = 0; i < ruralWomenPropertyNames.length; i++) {
              const propertyName = ruralWomenPropertyNames[i];
              if (propertyName.endsWith('IsRequiredRemark')) {
                if(itemData[id][propertyName]===true){
                      toast.error(`Please select the Remark`, messages.COLOR_RED);
                      return false;
                }
              
              }
            }
      }

      
          if(buttonType ==="SUBMIT"){
            statusFlag = clickButtonStatusFlag;
          }
          if (buttonType === "ACCEPT" || buttonType === "SAVE" ) { //Accept Button click
            statusFlag = clickButtonStatusFlag;
          }
        
       
          if (buttonType === "REJECT") { //Reject Button click condition
            statusFlag = clickButtonStatusFlag;
           if(RejectRemark ===''){
            toast.error(`Please Enter Reject Remarks`, messages.COLOR_RED);
            return false;
          }
       
         
        }  
      
      const customObject = {
         CowTotalWages : CowTotalWages,
         BuffaloTotalWages :BuffaloTotalWages,
         ShowingTotalWages : ShowingTotalWages,
         WeddingTotalWages : WeddingTotalWages,
         HarvestingTotalWages :HarvestingTotalWages,
         ThreshingTotalWages :ThreshingTotalWages,
         OtherTotalWages : OtherTotalWages,
         RemarkCow:RemarkCow,
         RemarkBuff:RemarkBuff,
         RemarkSowing:RemarkSowing,
         RemarkWeeding:RemarkWeeding,
         RemarkHarvest:RemarkHarvest,
         RemarkThresh:RemarkThresh,
         RemarkOther:RemarkOther,
         RejectRemark: RejectRemark,
         BlockCode:BlockCode,
         BlockName:BlockName,
         statusFlag : statusFlag
      }     
      customItemCodes.push(customObject);

    }

   }

   let postData = {
    itemCodes: customItemCodes,
    payload: {
        month_name: monthName,
        year_name: yearName,
        district_code: districtCode,
        buttonType: buttonType,
        statusButtonFlag:clickButtonStatusFlag
    }
}

showLoading(true)
      try {
      
        const response = await axios.post(`${API_URL}api/labourWages/RuralLabourWagesRatesFormWomenSaveDataDB`, postData, config);
        if (response.data.status) {
          toast.success(response.data.message, messages.COLOR_RED);
          }
      } catch (error) {
        console.error(error);
        toast.error('An error occurred while processing your request.', messages.COLOR_RED);
      } finally {
        showLoading(false);
        resetForm()
        
      }




}



{/* Show remark Text for the post Data*/}
const handleRemarkTextForPost=(remarkSelectedValue,remarkText)=>{


  let remarkTextForPost='NQ';
  let text='';

  if(remarkSelectedValue){
    text=remarkSelectedValue;
  }else{
    text=remarkText;
  }
  
   if(userInfoObject.userLevel ==='HEAD QUARTER' &&   
      headQuarterRemark.includes(text)){
      remarkTextForPost=text

     }

    if(userInfoObject.userLevel !=='HEAD QUARTER' &&   
        otherRemark.includes(text)){
          remarkTextForPost=text

    }
   return remarkTextForPost;
 }




  return (
    <div className="card-body">
    {/* <ToastContainer/> */}
    <div className="table-responsive">
    <table cellPadding="6" className="table table-bordered text-nowrap text-center">
                        <thead>
                        <tr>
                                  <th rowSpan="3">&nbsp;</th>
                                  <th rowSpan="3">{storedLanguage === 'hi' ? priceTitle.hi.Serial_No : priceTitle.en.Serial_No}</th>
                                  <th rowSpan="2">{storedLanguage === 'hi' ? priceTitle.hi.Business_Measurement : priceTitle.en.Business_Measurement}</th>
                                  <th colSpan="4">{storedLanguage === 'hi' ? priceTitle.hi.Charwaha_Per_Month : priceTitle.en.Charwaha_Per_Month}</th>
                                  <th rowSpan="2" colSpan="2">{storedLanguage === 'hi' ? priceTitle.hi.Sowing : priceTitle.en.Sowing}</th>
                                  <th rowSpan="2" colSpan="2">{storedLanguage === 'hi' ? priceTitle.hi.Weeding : priceTitle.en.Weeding}</th>
                                  <th rowSpan="2" colSpan="2">{storedLanguage === 'hi' ? priceTitle.hi.Harvesting : priceTitle.en.Harvesting}</th>
                                  <th rowSpan="2" colSpan="2">{storedLanguage === 'hi' ? priceTitle.hi.Threshing : priceTitle.en.Threshing}</th>
                                  <th rowSpan="2" colSpan="2">{storedLanguage === 'hi' ? priceTitle.hi.Other : priceTitle.en.Other}</th>
                              </tr>
                              <tr>
                                  <th colSpan="2">{storedLanguage === 'hi' ? priceTitle.hi.Cow : priceTitle.en.Cow}</th>
                                  <th colSpan="2">{storedLanguage === 'hi' ? priceTitle.hi.Buffalow : priceTitle.en.Buffalow}</th>
                              </tr>
                              <tr>
                                  <th>{storedLanguage === 'hi' ? priceTitle.hi.Block : priceTitle.en.Block}</th>
                                  <th>{storedLanguage === 'hi' ? priceTitle.hi.Total_Wages : priceTitle.en.Total_Wages}</th>
                                  <th>{storedLanguage === 'hi' ? priceTitle.hi.REMARKS : priceTitle.en.REMARKS}</th>
                                  <th>{storedLanguage === 'hi' ? priceTitle.hi.Total_Wages : priceTitle.en.Total_Wages}</th>
                                  <th>{storedLanguage === 'hi' ? priceTitle.hi.REMARKS : priceTitle.en.REMARKS}</th>
                                  <th>{storedLanguage === 'hi' ? priceTitle.hi.Total_Wages : priceTitle.en.Total_Wages}</th>
                                  <th>{storedLanguage === 'hi' ? priceTitle.hi.REMARKS : priceTitle.en.REMARKS}</th>
                                  <th>{storedLanguage === 'hi' ? priceTitle.hi.Total_Wages : priceTitle.en.Total_Wages}</th>
                                  <th>{storedLanguage === 'hi' ? priceTitle.hi.REMARKS : priceTitle.en.REMARKS}</th>
                                  <th>{storedLanguage === 'hi' ? priceTitle.hi.Total_Wages : priceTitle.en.Total_Wages}</th>
                                  <th>{storedLanguage === 'hi' ? priceTitle.hi.REMARKS : priceTitle.en.REMARKS}</th>
                                  <th>{storedLanguage === 'hi' ? priceTitle.hi.Total_Wages : priceTitle.en.Total_Wages}</th>
                                  <th>{storedLanguage === 'hi' ? priceTitle.hi.REMARKS : priceTitle.en.REMARKS}</th>
                                  <th>{storedLanguage === 'hi' ? priceTitle.hi.Total_Wages : priceTitle.en.Total_Wages}</th>
                                  <th>{storedLanguage === 'hi' ? priceTitle.hi.REMARKS : priceTitle.en.REMARKS}</th>
                              </tr>
                        </thead>
                        <tbody>
                       { Object.values(itemData).map((item,i) => {
                            srNo=i
                            return (
                            <tr key={i}>
                               
                                <td>
                                {i !==0 &&
                                <input 
                                type="checkbox"
                                id={`checkbox-${i}-id`}
                                checked={checkedItems.includes(i)}
                                onChange={(event) => handleCheckboxChange(event, i)}
                                />
                                }
                               </td>
                                <td>{++srNo}</td>
                                <td>
                                    <select 
                                      className="form-select" 
                                      value={`${itemData[item.id]?.BlockName}` || ''}
                                      onChange={e => handleOnChange(item.id, 'BlockName', e.target.value)}
                                      disabled={(Object.values(itemData).length===1 && districtCode === '')
                                        || (isSubmitBtnDisable || isAcceptBtnDisable || isRejectBtnDisable || isSaveBtnDisable)
                                      }
                                      >
                                        <option>Select</option>
                                        {blockAllData.map((nm,index)=>(
                                          <option 
                                            key={index} 
                                            value={`${nm.BlockName}`}
                                            >
                                          {nm.BlockName}
                                        </option>
                                      ))}
                                    </select>
                                </td>
                                <td>
                                    <input 
                                    type="text" 
                                    className="form-control"
                                    maxLength="6"
                                    inputMode="numeric"
                                    pattern="[0-9]*"
                                    name={`CowTotalWages${i}`}
                                    id={`CowTotalWages${i}`}
                                    style={itemData[item.id]?.CowTotalWagesStyle || {}}
                                    value={itemData[item.id]?.CowTotalWages || ""}
                                    onChange={e => handleOnChange(item.id, 'CowTotalWages', e.target.value)}
                                    onBlur={e=>handleCheckVariation(item.id, 'CowTotalWagesStyle','CowTotalWagesIsRequiredRemark', parseFloat(e.target.value),item.cowTotalWagesAvg,10)}
                                    
                                    />
                                </td>
                                <td>
                                  {remarkDropDown(item,i,'RemarkCowSelectValue','RemarkCow','CowTotalWagesIsRequiredRemark')}
                                </td>
                                <td>
                                    <input 
                                    type="text" 
                                    className="form-control"
                                    maxLength="6"
                                    inputMode="numeric"
                                    pattern="[0-9]*"
                                    name={`BuffaloTotalWages${i}`}
                                    id={`BuffaloTotalWages${i}`}
                                    style={itemData[item.id]?.BuffaloTotalWagestyle || {}}
                                    value={itemData[item.id]?.BuffaloTotalWages || ""}
                                    onChange={e => handleOnChange(item.id, 'BuffaloTotalWages', e.target.value)}
                                    onBlur={e=>handleCheckVariation(item.id, 'BuffaloTotalWagesStyle','BuffaloTotalWagesIsRequiredRemark', parseFloat(e.target.value),item.buffaloTotalWagesAvg,10)}
                                    
                                    />
                                </td>
                                <td>
                                {remarkDropDown(item,i,'RemarkBuffSelectValue','RemarkBuff','BuffaloTotalWagesIsRequiredRemark')}
                                </td>
                                <td>
                                    <input 
                                    type="text" 
                                    className="form-control"
                                    maxLength="6"
                                    inputMode="numeric"
                                    pattern="[0-9]*"
                                    name={`ShowingTotalWages${i}`}
                                    id={`ShowingTotalWages${i}`}
                                    style={itemData[item.id]?.ShowingTotalWagesStyle || {}}
                                    value={itemData[item.id]?.ShowingTotalWages || ""}
                                    onChange={e => handleOnChange(item.id, 'ShowingTotalWages', e.target.value)}
                                    onBlur={e=>handleCheckVariation(item.id, 'ShowingTotalWagesStyle','ShowingTotalWagesIsRequiredRemark', parseFloat(e.target.value),item.showingTotalWagesAvg,10)}
                                    />
                                </td>
                                <td>
                                {remarkDropDown(item,i,'RemarkSowingSelectValue','RemarkSowing','ShowingTotalWagesIsRequiredRemark')}
                                </td>
                                <td>
                                  
                                    <input 
                                    type="text" 
                                    className="form-control"
                                    name={`WeddingTotalWages${i}`}
                                    id={`WeddingTotalWages${i}`}
                                    maxLength="6"
                                    inputMode="numeric"
                                    pattern="[0-9]*"
                                    style={itemData[item.id]?.WeddingTotalWagesStyle || {}}
                                    value={itemData[item.id]?.WeddingTotalWages || ""}
                                    onChange={e => handleOnChange(item.id, 'WeddingTotalWages', e.target.value)}
                                    onBlur={e=>handleCheckVariation(item.id, 'WeddingTotalWagesStyle','WeddingTotalWagesIsRequiredRemark', parseFloat(e.target.value),item.weddingTotalWagesAvg,10)}
                                    
                                    />
                                </td>
                                <td>
                                {remarkDropDown(item,i,'RemarkWeedingSelectValue','RemarkWeeding','WeddingTotalWagesIsRequiredRemark')}
                                </td>
                                <td>
                                
                                <input 
                                    type="text" 
                                    className="form-control"
                                    maxLength="6"
                                    inputMode="numeric"
                                    pattern="[0-9]*"
                                    name={`HarvestingTotalWages${i}`}
                                    id={`HarvestingTotalWages${i}`}
                                    style={itemData[item.id]?.HarvestingTotalWagesStyle || {}}
                                    value={itemData[item.id]?.HarvestingTotalWages || ""}
                                    onChange={e => handleOnChange(item.id, 'HarvestingTotalWages', e.target.value)}
                                    onBlur={e=>handleCheckVariation(item.id, 'HarvestingTotalWagesStyle','HarvestingTotalWagesIsRequiredRemark', parseFloat(e.target.value),item.harvestingTotalWagesAvg,10)}
                                    
                                    />
                                </td>
                                <td>
                                {remarkDropDown(item,i,'RemarkHarvestSelectValue','RemarkHarvest','HarvestingTotalWagesIsRequiredRemark')}
                                </td>
                                <td>
                                
                                <input 
                                    type="text" 
                                    className="form-control"
                                    maxLength="6"
                                    inputMode="numeric"
                                    pattern="[0-9]*"
                                    name={`ThreshingTotalWages${i}`}
                                    id={`ThreshingTotalWages${i}`}
                                    style={itemData[item.id]?.ThreshingTotalWagesStyle || {}}
                                    value={itemData[item.id]?.ThreshingTotalWages || ""}
                                    onChange={e => handleOnChange(item.id, 'ThreshingTotalWages', e.target.value)}
                                    onBlur={e=>handleCheckVariation(item.id, 'ThreshingTotalWagesStyle','ThreshingTotalWagesIsRequiredRemark', parseFloat(e.target.value),item.threshingTotalWagesAvg,10)}
                                   />
                                </td>
                                <td>
                                {remarkDropDown(item,i,'RemarkThreshSelectValue','RemarkThresh','ThreshingTotalWagesIsRequiredRemark')}
                                </td>
                                <td>
                                
                                <input 
                                    type="text" 
                                    className="form-control"
                                    maxLength="6"
                                    inputMode="numeric"
                                    pattern="[0-9]*"
                                    name={`OtherTotalWages${i}`}
                                    id={`OtherTotalWages${i}`}
                                    style={itemData[item.id]?.OtherTotalWagesStyle || {}}
                                    value={itemData[item.id]?.OtherTotalWages || ""}
                                    onChange={e => handleOnChange(item.id, 'OtherTotalWages', e.target.value)}
                                    onBlur={e=>handleCheckVariation(item.id, 'OtherTotalWagesStyle','OtherTotalWagesIsRequiredRemark', parseFloat(e.target.value),item.otherTotalWagesAvg,10)}
                                   />
                                </td>
                                <td>
                                {remarkDropDown(item,i,'RemarkOtherSelectValue','RemarkOther','OtherTotalWagesIsRequiredRemark')}
                                </td>
                               
                            </tr>
                            );
                            })
                      }
                      {averageData && (
                      <tr>
                        <td></td>
                        <td></td>
                        <td>Average</td>
                        
                            <>
                              <td>{averageData.avgCowTotalWages ? averageData.avgCowTotalWages.toFixed(2):0}</td>
                              <td></td>
                              <td>{averageData.avgBuffaloTotalWages ? averageData.avgBuffaloTotalWages.toFixed(2):0}</td>
                              <td></td>
                              <td>{averageData.avgShowingTotalWages ? averageData.avgShowingTotalWages.toFixed(2):0}</td>
                              <td></td> 
                              <td>{averageData.avgWeddingTotalWages ? averageData.avgWeddingTotalWages.toFixed(2):0}</td>
                              <td></td>
                              <td>{averageData.avgHarvestingTotalWages ? averageData.avgHarvestingTotalWages.toFixed(2):0}</td>
                              <td></td>
                              <td>{averageData.avgThreshingTotalWages ? averageData.avgThreshingTotalWages.toFixed(2):0}</td>
                              <td></td>
                              <td>{averageData.avgOtherTotalWages ? averageData.avgOtherTotalWages.toFixed(2):0}</td>
                              <td></td>
                            </>
                          

                      </tr>
                    )}

                            <tr>
                                <td colSpan="2" className="fw-bold">Remark</td>
                                <td colSpan="15">
                                    <textarea 
                                    className="form-control h-auto" 
                                    onChange={e => handleOnChange(0, 'RejectRemark', e.target.value)}
                                    value={itemData[0]?.RejectRemark}
                                    rows="3">
                                    </textarea>
                                </td>
                            </tr>
                        </tbody>
                    </table>
    
                  </div>
            <div className="row">
             <div className="col-12 text-center pt-3">
              <button
                type="button"
                onClick={addRow}
                disabled={(Object.values(itemData).length===blockAllData.length)
                  || (isSubmitBtnDisable || isAcceptBtnDisable || isRejectBtnDisable || isSaveBtnDisable)}
                className="btn btn_orange mx-1"
              >
                Add Row
              </button>

              <button
                type="button"
                onClick={deleteRows}
                disabled={isSubmitBtnDisable || isAcceptBtnDisable || isRejectBtnDisable || isSaveBtnDisable}
                className="btn btn_orange mx-1"
              >
                Delete Row
              </button>
              <button 
                type="button" 
                className={`btn btn_orange mx-1 ${isSaveBtnDisable ? 'disabled' : ''}`}
                onClick={(e)=>handleRuralWomannWagesFormData(e,'SAVE')} 
              >
                Save
              </button>

              {
              (userInfoObject.userLevel === 'DISTRICT LEVEL' ||
                userInfoObject.userLevel === 'DIVISION LEVEL') &&

                <button
                type="submit"
                className={`btn btn_orange mx-1 ${isSubmitBtnDisable ? 'disabled' : ''}`}
                onClick={(e) => handleRuralWomannWagesFormData(e, 'SUBMIT')}
                >
                Submit
               </button>
            }

            {(userInfoObject.userLevel === 'HEAD QUARTER') &&
              <>
                <button 
                type="submit" 
                className={`btn btn_orange mx-1 ${isAcceptBtnDisable ? 'disabled' : ''}`}
                onClick={(e)=>handleRuralWomannWagesFormData(e,'ACCEPT')} 
                >
                 Accept
                </button>

                <button 
                type="submit" 
                className={`btn btn_orange mx-1 ${isRejectBtnDisable ? 'disabled' : ''}`}
                onClick={(e)=>handleRuralWomannWagesFormData(e,'REJECT')} 
                >
                Reject
               </button>

              </>
            }

              <button 
                type="reset" 
                className="btn btn_orange mx-1"
                onClick={resetForm} 
                >
                Reset
              </button>

              <button 
              type="button" 
              className="btn btn_orange mx-1" 
              onClick={(e)=>( navigate("/dashboard"))} 
              >
              Cancel
              </button>
             </div>
          </div>

                </div>
  )
}

export default RuralWomenWagesData